$(function () {

    /*
    $('.width, .radius, .category, .brand').change(function () {

        var chkwidth = $('.width').val();
        var chkradius = $('.radius').val();
        var chkcategory = $('.category').val();
        var chkbrand = $('.brand').val();


        $.ajaxSetup(
            {
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            });
        $.ajax(
            {
                type: 'POST',
                url: '/search-options',
                data: {
                    width: $('.width').val(),
                    radius: $('.radius').val(),
                    //ha nincs kategória kiválasztva, akkor az alapkategória id-t használja
                    category: $('.category').val(),
                    categoryId: $('#category-id-detail').val(),
                    brand: $('.brand').val()
                },
                success: function (response) {
                    let width = response[0];
                    let radius = response[1];
                    let category = response[2];
                    let brand = response[3];

                    let width_options = '';
                    let radius_options = '';
                    let brand_options = '';
                    let category_options = '';

                    $.each(width, (key, value) => {
                        width_options += `<option value="${value}">$
                                    {
                                        value
                                    }</option>`;
                    });

                    $.each(radius, (key, value) => {
                        radius_options += `<option value="${value}">$
                                    {
                                        value
                                    }</option>`;
                    });

                    $.each(brand, (key, value) => {
                        brand_options += `<option value="${key}">$
                                    {
                                        value
                                    }</option>`;
                    });

                    $.each(category, (key, value) => {
                        category_options += `<option value="${key}">$
                                    {
                                        value
                                    }</option>`;
                    });

                    $('.width')
                        .find('option')
                        .remove()
                        .end()
                        .append(width_options)
                        .val(chkwidth);

                    $('.radius')
                        .find('option')
                        .remove()
                        .end()
                        .append(radius_options)
                        .val(chkradius);

                    $('.brand')
                        .find('option')
                        .remove()
                        .end()
                        .append(brand_options)
                        .val(chkbrand);

                    $('.category')
                        .find('option')
                        .remove()
                        .end()
                        .append(category_options)
                        .val(chkcategory);

                }
            });
    });

   */
});